// The Agnihotri Archives: Who Said It?
// Curated quotes from Dhruv & Aastha's WhatsApp chat
// Kanni = Aastha (nickname / wife)

export const GAME_QUESTIONS = [
  {
    id: 1,
    quote: "Khane baitha dia isne lekin esi jagah jaha kuch chicken ya veg nhi h... Seafood h... Maan he nhi raha",
    answer: "Dhruv",
    category: "food",
    difficulty: "easy",
    hint: "Aven says: Papa gets dragged to restaurants he doesn't like",
  },
  {
    id: 2,
    quote: "Aapko khana khilaane ka mann kr ra",
    answer: "Aastha",
    category: "romantic",
    difficulty: "easy",
    hint: "Aven says: Only one person cooks in this house... and it's not Papa",
  },
  {
    id: 3,
    quote: "I ate two meals... Qty was less",
    answer: "Aastha",
    category: "food",
    difficulty: "medium",
    hint: "Aven says: The foodie energy is STRONG with this one",
  },
  {
    id: 4,
    quote: "Kuch poocho Jese Saari kesi lag ri h? Eyes kesi lag ri h? Face kesa lag ra h? Overall kesi lag ri Hu?",
    answer: "Dhruv",
    category: "funny",
    difficulty: "easy",
    hint: "Aven says: Papa made a TUTORIAL for giving compliments. Engineer brain.",
  },
  {
    id: 5,
    quote: "Tareef kro ❤️ Baby ki... Mehnat lagi hai saree mei... Bhari thi kaafi",
    answer: "Aastha",
    category: "funny",
    difficulty: "easy",
    hint: "Aven says: Someone had to ASK for compliments because Papa said 'By default'",
  },
  {
    id: 6,
    quote: "I miss making chapatis for you",
    answer: "Aastha",
    category: "romantic",
    difficulty: "medium",
    hint: "Aven says: This person shows love through food, not code",
  },
  {
    id: 7,
    quote: "Games ka department toh tumhara hi rahega",
    answer: "Aastha",
    category: "life",
    difficulty: "medium",
    hint: "Aven says: One parent handles games, the other handles EVERYTHING else",
  },
  {
    id: 8,
    quote: "It's the best game of all time... Iske launch pe 2016 me Dunia pagal hogyi thi",
    answer: "Dhruv",
    category: "funny",
    difficulty: "easy",
    hint: "Aven says: Only one person in this house gives TED talks about video games",
  },
  {
    id: 9,
    quote: "Main 3 cocktails ko mocktail mei convert krwa chuki hu 😂 Ye wala bana do without vodka",
    answer: "Aastha",
    category: "funny",
    difficulty: "medium",
    hint: "Aven says: Mama hacks the bar menu like Papa hacks code",
  },
  {
    id: 10,
    quote: "Govt job pta hai milni kitni mushkil hai aaj ki date mei 😂 Life set hai mil jaye toh",
    answer: "Aastha",
    category: "life",
    difficulty: "medium",
    hint: "Aven says: The practical one in this marriage... and it's not the engineer",
  },
  {
    id: 11,
    quote: "Baby ko ye acha nai laga",
    answer: "Aven",
    category: "aven",
    difficulty: "twist",
    hint: "Aven says: Hmm... neither sounds like Mama or Papa... who could it be? 🤔",
    isAvenTwist: true,
  },
  {
    id: 12,
    quote: "Creative lag ri ho",
    answer: "Dhruv",
    category: "funny",
    difficulty: "easy",
    hint: "Aven says: When asked for a REAL compliment, this was the best attempt 😂",
  },
  {
    id: 13,
    quote: "Desi khana is best yr",
    answer: "Aastha",
    category: "food",
    difficulty: "hard",
    hint: "Aven says: The desi food loyalist of the family",
  },
  {
    id: 14,
    quote: "Papa khana daal ke de Rahe munhe",
    answer: "Dhruv",
    category: "funny",
    difficulty: "easy",
    hint: "Aven says: Michigan grad, Salesforce engineer... still being fed by Papa 😂",
  },
  {
    id: 15,
    quote: "Aap toh mere pyaar me paagal the na lekin us tym 😂",
    answer: "Aastha",
    category: "romantic",
    difficulty: "medium",
    hint: "Aven says: The savage flirt of this couple",
  },
  {
    id: 16,
    quote: "Abhi biscuit and kaam. Aur miss.",
    answer: "Dhruv",
    category: "life",
    difficulty: "hard",
    hint: "Aven says: Biscuit + Work + Missing wife = Papa's entire evening",
  },
  {
    id: 17,
    quote: "Maine bs muh band krane ke liye lga lia feed pe",
    answer: "Aastha",
    category: "parenting",
    difficulty: "medium",
    hint: "Aven says: Hey! That's classified information about my feeding schedule!",
  },
  {
    id: 18,
    quote: "He is gem. He is best. He is my boy. Bestest baby.",
    answer: "Dhruv",
    category: "parenting",
    difficulty: "medium",
    hint: "Aven says: Someone gets VERY emotional about me on chat 🥰",
  },
  {
    id: 19,
    quote: "He is such a pious soul",
    answer: "Aastha",
    category: "parenting",
    difficulty: "hard",
    hint: "Aven says: One parent calls me 'pious soul', the other calls me 'bestest baby'",
  },
  {
    id: 20,
    quote: "Major missing... Kissi krne ka mann kr gya",
    answer: "Aastha",
    category: "romantic",
    difficulty: "hard",
    hint: "Aven says: Papa replied 'Awww awww awww finally' to this 😂",
  },
];

export const AVEN_LIFELINE_HINTS = [
  "Aven says: Papa solves every problem with 'Order food'",
  "Aven says: Mama sends 47 reels a day. NON-NEGOTIABLE.",
  "Aven says: Papa types 'Huh' and 'Hmm' more than actual words",
  "Aven says: If it's about managing something, it's Mama. 100%.",
  "Aven says: Papa's love language is asking 'Kya khana h?'",
  "Aven says: Mama plans. Papa vibes. That's the system.",
  "Aven says: If there's a 😂 emoji, it's probably Mama",
  "Aven says: Papa thinks saying 'By default' is a compliment",
  "Aven says: Mama once converted 3 cocktails into mocktails at a party",
  "Aven says: Papa calls everyone 'Mooli' when he misses them",
  "Aven says: If it's about food passion, it's Mama. If it's about food laziness, it's Papa.",
  "Aven says: Mama types paragraphs. Papa types fragments.",
  "Aven says: Papa's emotional range: Huh -> Hmm -> Bye -> ❤️",
  "Aven says: When in doubt, if it's sweet, it's Mama!",
  "Aven says: I am literally sleeping on Mama's lap right now. Ask later. 😴",
];

export const CATEGORIES = {
  food: { label: "Foodie Wars", color: "#ff9a9e", icon: "🍕" },
  romantic: { label: "Love Letters", color: "#ff6b9d", icon: "💕" },
  funny: { label: "Comedy Gold", color: "#ffd93d", icon: "😂" },
  life: { label: "Daily Drama", color: "#6bcb77", icon: "🏠" },
  parenting: { label: "Baby Aven Era", color: "#4d96ff", icon: "👶" },
  aven: { label: "The Twist!", color: "#c44569", icon: "🎭" },
};

export const FINAL_LOVE_LETTER = `Dear Aastha,

From "Good morning bubu ❤️" to midnight calls about mango shakes, from saree compliment tutorials to converting cocktails into mocktails...

Every chat, every "Huh", every "Hmm", every fight about who misses whom more — it's all ours.

You're the Manager of our little Agnihotri household, the chapati maker I miss across oceans, and the best mama Aven could ever have.

Happy Valentine's Day, Mooli. ❤️

— Dhruv (& Boss Baby Aven)`;
